import i18n from 'i18next'

import { AnomalyStrategy, SelectOption } from './types'

const strategyDescriptionI18nKeys = {
  padim: i18n.t('Good performances and faster inference speed'),
  patchcore: i18n.t('Best performances slightly reduced inference speed'),
}

export const anomalyStrategyToOption = () => (
  anomalyStrategy: AnomalyStrategy
): SelectOption => ({
  value: anomalyStrategy.id.toString(),
  label: anomalyStrategy.name,
  description:
    anomalyStrategy.code in strategyDescriptionI18nKeys
      ? strategyDescriptionI18nKeys[
          anomalyStrategy.code as keyof typeof strategyDescriptionI18nKeys
        ]
      : anomalyStrategy.description,
})
